// extracted by mini-css-extract-plugin
module.exports = {"title":"ReviewRefund_title__34qB5","responses":"ReviewRefund_responses__3nfjW","separator":"ReviewRefund_separator__2uosC"};